import classNames from 'classnames'
import { Editor, Element as SlateElement, Transforms } from 'slate'
import { useSlate } from 'slate-react'

const LIST_TYPES = ['numbered-list', 'bulleted-list']
const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']

const isBlockActive = (editor, format, blockType = 'type') => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Editor.nodes(editor, {
    at: Editor.unhangRange(editor, selection),
    match: (n) => {
      // @ts-ignore
      return !Editor.isEditor(n) && SlateElement.isElement(n) && n[blockType] === format
    }
  })

  return !!match
}

const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type')
  const isList = LIST_TYPES.includes(format)

  Transforms.unwrapNodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) &&
      SlateElement.isElement(n) &&
      LIST_TYPES.includes((n as any).type) &&
      !TEXT_ALIGN_TYPES.includes(format),
    split: true
  })
  const newProperties: Partial<SlateElement> = {}
  if (TEXT_ALIGN_TYPES.includes(format)) {
    Object.assign(newProperties, {
      align: isActive ? undefined : format
    })
  } else {
    Object.assign(newProperties, {
      type: isActive ? 'paragraph' : isList ? 'list-item' : format
    })
  }
  Transforms.setNodes(editor, newProperties as any)

  if (!isActive && isList) {
    const block = { type: format, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

const BlockButton = ({ format, icon }) => {
  const editor = useSlate()
  return (
    <button
      type='button'
      className={classNames('icon-btn', {
        'icon-btn-active': isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type')
      })}
      onMouseDown={(event) => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
    >
      {icon}
    </button>
  )
}

export default BlockButton
